var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-button',{on:{"click":function($event){$event.stopPropagation();return _vm.confirmAndDelete()}}},[(_vm.busy)?_c('ion-spinner',{attrs:{"color":"light"}}):_c('ion-icon',{attrs:{"src":_vm.i.trash}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }